// extracted by mini-css-extract-plugin
export default {"collapse":"Content_collapse__1Rgto","collapseContainer":"Content_collapseContainer__5LwUS","collapseWrapperInner":"Content_collapseWrapperInner__5T3zI","h100":"Content_h100__1BNFd"};